import React from "react";
import {Button, ButtonGroup, Table} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

const FileOverviewTab = props => {

  const humanReadableFileSize = (size) => {
    const labels = ["B", "KB", "MB", "GB"];
    let ct = 0;
    while (size > 1024 && ct < labels.length) {
      size /= 1024;
      ct++;
    }
    return `${Math.round(size * 100) / 100} ${labels[ct]}`;
  }

  return (
      <div>
        <Table size="sm mt-2">
          <thead>
          <tr>
            <th>
              {props.t(
                  "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileOverviewTab.ColumnFilename"
              )}
            </th>
            <th>
              {props.t(
                  "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileOverviewTab.ColumnFileSize"
              )}
            </th>
            <th />
          </tr>
          </thead>
          <tbody>{props.studentExaminationFiles.length > 0 ? (
              props.studentExaminationFiles.map((i, idx) => (
                  <tr key={idx}>
                    <td>{i.name}</td>
                    <td>{humanReadableFileSize(i.size)}</td>
                    <td>
                      <div className="floatRight">
                        <ButtonGroup size="sm">
                          <Button
                              className="btn-red"
                              onClick={() => props.onDelete(i._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} size="1x" />
                          </Button>
                        </ButtonGroup>
                      </div>
                    </td>
                  </tr>
              ))) : (
              <tr>
                <td colSpan="3">
                  {props.t(
                      "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileOverviewTab.NoUploadsFound"
                  )}
                </td>
              </tr>
              )}</tbody>
        </Table>
      </div>
  );
}

export default withTranslation()(FileOverviewTab);
